import { render, staticRenderFns } from "./ConfigSolicitations.vue?vue&type=template&id=8fea526c"
import script from "./ConfigSolicitations.vue?vue&type=script&lang=js"
export * from "./ConfigSolicitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports